/** @jsx h */
import { h } from "hyperapp";
import classNames from "classnames";
import { WrappedSvg } from "../../../utilities/hyperapp";
import { iOS } from "../../../sniffer";

import startIcon from "!svg-inline-loader?removeSVGTagAttrs=false!../../../player-controls/start-icon.svg";
import endIcon from "!svg-inline-loader?removeSVGTagAttrs=false!../../../player-controls/end-icon.svg";
import volumeIcon from "!svg-inline-loader?removeSVGTagAttrs=false!../../../player-controls/volume-icon.svg";
import muteIcon from "!svg-inline-loader?removeSVGTagAttrs=false!../../../player-controls/mute-icon.svg";

export default function PlayerControls({
  target,
  muted,
  volume,
  quality,
  set
}) {
  return (
    <div class="player-controls d-flex flex-items-v-center">
      {/* Hiding these instead of removing them from the DOM because there are some rendering artefacts for SVGs */}
      <button
        class={classNames("player-controls__catchup", {
          "hide-from-all": !target.isLive()
        })}
        onclick={() => target.catchUp()}
      >
        Catch up
      </button>
      <button
        aria-label="Go to previous track"
        class={classNames("player-controls__start", "player-controls__icon", {
          "hide-from-all": target.isLive()
        })}
        onclick={() => target.prev()}
        disabled={!target.canPlayPrev()}
        ga-on="click,auxclick,contextmenu"
        ga-event-category="audio"
        ga-event-action="go to previous track"
      >
        <WrappedSvg data={startIcon} />
      </button>
      <button
        aria-label="Go to next track"
        class={classNames("player-controls__end", "player-controls__icon", {
          "hide-from-all": target.isLive()
        })}
        onclick={() => target.next()}
        disabled={!target.canPlayNext()}
        ga-on="click,auxclick,contextmenu"
        ga-event-category="audio"
        ga-event-action="go to next track"
      >
        <WrappedSvg data={endIcon} />
      </button>
      <button
        class={classNames(
          "player-controls__volume-icons",
          "player-controls__icon",
          { "player-controls__volume-icons--is-muted": muted }
        )}
        onclick={e => set({ muted: !muted })}
      >
        <span aria-label="Mute audio" class="player-controls__volume-icon">
          <WrappedSvg data={volumeIcon} />
        </span>
        <span aria-label="Unmute audio" class="player-controls__mute-icon">
          <WrappedSvg data={muteIcon} />
        </span>
      </button>
      <div
        aria-label={`Volume at ${volume * 100}%`}
        class={classNames("player-controls__volume", {
          "player-controls__volume--hidden": iOS
        })}
      >
        <span class="hide-visually">Slider to adjust volume</span>
        <input
          class="player-controls__volume-slider"
          type="range"
          min="0.05"
          max="1"
          step="0.05"
          value={volume}
          oninput={e => set({ volume: e.target.valueAsNumber })}
        />
      </div>
      {target.isLive() ? null : (
        <button
          class={`player-controls__quality player-controls__quality--${quality}`}
          aria-label={`Toggle quality from ${quality} to ${
            quality === "high" ? "low" : "high"
          }`}
          disabled={!target.canToggleQuality()}
          onclick={e => set({ quality: quality === "high" ? "low" : "high" })}
          ga-on="click,auxclick,contextmenu"
          ga-event-category="audio"
          ga-event-action="toggle quality"
          ga-event-label={quality === "high" ? "low" : "high"}
        >
          <span class="player-controls__quality-high">High</span>
          <span class="player-controls__quality-low">Low</span>
        </button>
      )}
    </div>
  );
}
